import { render, staticRenderFns } from "./MarginList.vue?vue&type=template&id=686fc3a2&scoped=true"
import script from "./MarginList.vue?vue&type=script&lang=js"
export * from "./MarginList.vue?vue&type=script&lang=js"
import style0 from "./MarginList.vue?vue&type=style&index=0&id=686fc3a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686fc3a2",
  null
  
)

export default component.exports